/* eslint-disable no-undef */
import React from "react";

// {getTranslate(LANGUAGE_KEYS.TEXT_BOT_ID)}

const LANGUAGES = {
    "TEXT_TITLE": ["K3 IDE", "K3 IDE"],
    "TEXT_GREETING": [`Hello [@]. Today is [@]`, `Xin chào [@]. Hôm nay là [@]`],
    "TEXT_BOT_ID": [`Bot ID`, `Bot ID`],
    "TEXT_JOB_ID": [`Job ID`, `Công việc`],
    "TEXT_ALL": [`All`, `Tất cả`],
    "TEXT_TASK": [`Task`, `Tác vụ`],
    "TEXT_FROM": [`From`, `Từ ngày`],
    "TEXT_SEARCH": [`Search`, `Tìm kiếm`],
    "TEXT_DAILY_VIEW": [`Daily View`, `Lượt xem hàng ngày`],
    "TEXT_PRICE_MIN": [`Price Min`, `Giá tối thiểu`],
    "TEXT_PRICE_MAX": [`Price Max`, `Giá tối đa`],
    "TEXT_SOLD_30_CALCULATE": [`Sold-30 Calculate`, `Ước tính bán 30 ngày`],
    "TEXT_REVENUE_30_CALCULATE": [`Revenue-30 Calculate`, `Ước tính doanh thu 30 ngày`],
    "TEXT_SOLD_30_COUNT": [`Sold-30 Count`, `Thực tế bán 30 ngày`],
    "TEXT_REVENUE_30_COUNT": [`Revenue-30 Count`, `Thực tế doanh thu 30 ngày`],
    "TEXT_FAVORITE": [`Favorite`, `Yêu thích`],
    "TEXT_FAVORITE_RATE": [`Favorite rate`, `Tỉ lệ yêu thích`],
    "TEXT_LAST_UPDATE": [`Last Update`, `Cập nhật cuối`],
    "TEXT_SORT_BY": [`Sort by`, `Sắp xếp theo`],
    "TEXT_SORT_ORDER": [`Sort order`, `Thứ tự sắp xếp`],
    "TEXT_PRICE": [`Price`, `Giá`],
    "TEXT_TOTAL_VIEWS": [`Total Views`, `Tổng lượt xem`],
    "TEXT_CREATED_DATE": [`Created date`, `Ngày tạo`],
    "TEXT_EIT_CREATE": [`EIT create`, `Ngày tạo EIT`],
    "TEXT_EIT_UPDATE": [`EIT update`, `Ngày update EIT`],
    "TEXT_LAST_CHECK_HEY": [`Last Check Hey`, `Cập nhật Hey`],
    "TEXT_FOUND_X_LISTINGS": [`Found [@] listings`, `Tìm thấy [@] sản phẩm`],
    "TEXT_FLOATING_SEARCH_FILTER": [`Floating Search Filter`, `Hiển thị Thanh tìm kiếm nổi`],
    "TEXT_PREVIOUS": [`Previous`, `Trước`],
    "TEXT_NEXT": [`Next`, `Sau`],
    "TEXT_DAY": [`day`, `ngày`],
    "TEXT_DAYS": [`days`, `ngày`],
    "TEXT_WEEK": [`week`, `tuần`],
    "TEXT_WEEKS": [`weeks`, `tuần`],
    "TEXT_MONTH": [`month`, `tháng`],
    "TEXT_MONTHS": [`months`, `tháng`],
    "TEXT_DECREASE": [`Decrease`, `Giảm dần`],
    "TEXT_INCREASE": [`Increase`, `Tăng dần`],
    "TEXT_CREATED": [`Created`, `Ngày tạo`],
    "TEXT_SEARCH_AND_FILTER": [`Search & Filter`, `Tìm kiếm & Lọc`],
    "TEXT_COMPETITOR_ANALYSIS": [`Competitor Analysis`, `Phân tích đối thủ`],
    "TEXT_VISIT_SHOP_X": [`Visit shop [@]`, `Xem shop [@]`],
    "TEXT_LISTING": [`Listing`, `Sản phẩm`],
    "TEXT_COLLECTION_DETAIL": [`Collection Detail`, `Chi tiết bộ sưu tập`],
    "TEXT_COLLECTION": [`Collection`, `Bộ sưu tập`],
    "TEXT_SHOP": [`Shop`, `Cửa hàng`],
    "TEXT_BOT": [`Bot`, `Bot`],
    "TEXT_3D_TOOL": [`3D Tool`, `Tool 3D`],
    "TEXT_BOX_MAKER": [`Box Maker`, `Vẽ Hộp`],
    "TEXT_DESIGN_LAMP_TOOL": [`Design Lamp Tool`, `Tool thiết kế đèn`],
    "TEXT_DASHBOARD": [`Dashboard`, `Dashboard`],
    "TEXT_USER_PROFILE": [`User Profile`, `Người dùng`],
    "TEXT_ENTER_KEYWORD": [`Enter keyword`, `Nhập từ khóa`],
    "TEXT_RUNNING_TASKS": [`Running Tasks`, `Tác vụ đang chạy`],
    "TEXT_AUTOMATICALLY_UPDATE_IN_X_SECONDS": [`Automatically update in [@] seconds`, `Tự động cập nhật sau [@] giây`],
    "TEXT_JOB": [`Job`, `Công việc`],
    "TEXT_STEP": [`Step`, `Bước`],
    "TEXT_STATUS": [`Status`, `Trạng thái`],
    "TEXT_PROGRESS": [`Progress`, `Tiến độ`],
    "TEXT_RUNNING_TIME": [`Running time`, `Thời gian chạy`],
    "TEXT_LAST_ACTIVITY": [`Last activity`, `Hoạt động lần cuối`],
    "TEXT_ACTION": [`Action`, `Hoạt động`],
    "TEXT_ASSIGN_JOB": [`Assign Job`, `Giao Việc`],
    "TEXT_X_HOURS_Y_MINUTES": [`[@] hours [@] minutes`, `[@] giờ [@] phút`],
    "TEXT_X_MINUTES_AGO": [`[@] minutes ago`, `[@] phút trước`],
    "TEXT_A_FEW_SECONDS_AGO": [`a few seconds ago`, `một vài giây trước`],
    "TEXT_X_HOURS_AGO": [`[@] hours ago`, `[@] giờ trước`],
    "TEXT_PING_TIME": [`Ping time`, `Thời gian ping`],
    "TEXT_CHECKIN_TIME": [`Checkin time`, `Thời gian checkin`],
    "TEXT_SCHEDULED_TASKS": [`Scheduled Tasks`, `Tác Vụ Lên Lịch`],
    "TEXT_SEARCH_KEYWORD": [`Search Keyword`, `Tìm Theo Từ Khóa`],
    "TEXT_SEARCH_TAG": [`Search Tag`, `Tìm Theo Tag`],
    "TEXT_SEARCH_BY_CATEGORY": [`Search By Category`, `Tìm Theo Danh Mục`],
    "TEXT_LISTINGS___SHOPS": [`Listings / Shops`, `Phân tích Sản phẩm / Cửa hàng`],
    "TEXT_TOTAL_SALES": ["Total sold", 'Tổng đơn'],
    "TEXT_SHOP_SOLD_30_DAYS": ["Sold 30 days", "Đơn 30 ngày"],
    "TEXT_SHOP_SOLD_90_DAYS": ["Sold 90 days", "Đơn 90 ngày"],
    "TEXT_RATING": ["Rating", "Điểm đánh giá"],
    "TEXT_OPENING_DATE": ["Opening Date", "Ngày mở shop"],
    "TEXT_FOUND_X_SHOPS": [`Found [@] shops`, `Tìm thấy [@] cửa hàng`],
    "TEXT_MIN": ["Min", "Nhỏ nhất"],
    "TEXT_MAX": ["Max", "Lớn nhất"],
    "TEXT_LAST_SOLD_DAYS": ["Last sold days", "Đơn gần nhất"],
    "TEXT_TOTAL_LISTINGS": ["Total listings", "Tổng số sản phẩm"],
    "TEXT_HOUR": ["hour", "giờ"],
    "TEXT_SOLD_CHART": ["Sold Chart", "Biển Đồ Sold"],
    "TEXT_IMAGE": ["Image", "Ảnh"],
    "TEXT_SKU_CODE": ["SKU Code", "Mã SKU"],
    "TEXT_SIZE": ["Size", "Kích cỡ"],
    "TEXT_STYLE": ["Style", "Kiểu dáng"],
    "TEXT_PRODUCT_NAME": ["Product Name", "Tên sản phẩm"],
    "TEXT_BASE_PRICE": ["Base Price", "Giá gốc"],
    "TEXT_CURRENT_QUANTITY": ["Current Quantity", "Tồn kho hiện tại"],
    "TEXT_MATERIAL": ["Material", "Chất liệu"],
    "TEXT_COLOR": ["Color", "Màu sắc"],
    "TEXT_DIMENSIONS": ["Dimensions", "Kích thước"],
    "TEXT_WEIGHT": ["Weight", "Khối lượng"],
    "TEXT_ACTIONS": ["Actions", "Thao tác"],
    "TEXT_VIEW": ["View", "Xem"],
    "TEXT_EDIT": ["Edit", "Sửa"],
    "TEXT_VERSIONS": ["Versions", "Version"],
    "TEXT_CLONE": ["Clone", "Nhân bản"],
    "TEXT_DELETE": ["Delete", "Xóa"],
    "TEXT_ADD_NEW_PRODUCT": ["Add New Product", "Thêm Sản Phẩm Mới"],
    "TEXT_PRODUCT_LIST": ["Product List", "Danh Sách Sản Phẩm"],
    "TEXT_PRODUCT_CODE": ["Product Code", "Mã Sản Phẩm"],
    "TEXT_PRODUCT_VERSION": ["Product Version", "Version Sản Phẩm"],
    "TEXT_PROPERTIES": ["Properties", "Thuộc tính"],
    "TEXT_IMAGES": ["Images", "Ảnh"],
    "TEXT_CLOSE": ["Close", "Đóng"],
    "TEXT_SAVE": ["Save", "Lưu"],
    "TEXT_VERSION": ["Version", "Version"],
    "TEXT_FRIENDLY_VERSION": ["Friendly Version", "Mã Version"],
    "TEXT_NOTE": ["Note", "Ghi chú"],
    "TEXT_LENGTH": ["Length (mm)", "Rộng (mm)"],
    "TEXT_WIDTH": ["Width (mm)", "Dày (mm)"],
    "TEXT_HEIGHT": ["Height (mm)", "Cao (mm)"],
    "TEXT_WAREHOUSE_ID": ["Warehouse ID", "Kho"],
    "TEXT_IMAGE_URL": ["Image URL", "Đường dẫn ảnh"],
    "TEXT_IMAGE_DESCRIPTION": ["Image Description", "Mô tả ảnh"],
    "TEXT_UPDATE_IMAGE": ["Update Image", "Cập nhật ảnh"],
    "TEXT_ADD_IMAGE": ["Add Image", "Thêm ảnh"],
    "TEXT_REMOVE": ["Remove", "Xóa"],
    "TEXT_PRODUCT": ["Product", "Sản phẩm"],
    "TEXT_SALE": ["Sale", "Bán hàng"],
    "TEXT_ADS": ["Ads", "Quảng cáo"],
    "TEXT_SALE_NGACH": ["Sale Ngách", "Sale Ngách"],
    "TEXT_SCAN_ORDERS": ["Scan Orders", "Quét đơn"],
    "TEXT_ORDER_LIST": ["Order List", "Danh sách đơn"],
    "TEXT_FULFILL": ["Fulfill", "Vận hành"],
    "TEXT_FACTORY": ["Factory", "Xưởng"],
    "TEXT_TABLE_LIST": ["Table List", "Bảng dữ liệu"],
    "TEXT_TYPOGRAPHY": ["Typography", "Kiểu chữ"],
    "TEXT_ICONS": ["Icons", "Biểu tượng"],
    "TEXT_IMPORT": ["Import", "Nhập hàng"],
    "TEXT_EXPORT": ["Export", "Xuất hàng"],
    "TEXT_QUANTITY_CHANGE": ["Quantity Change", "Lịch sử kho"],
    "TEXT_TRANSACTIONS": ["Transactions", "Lịch sử giao nhận"],
    "TEXT_INVENTORY": ["Inventory", "Kho hàng"],
    "TEXT_PRODUCT_UPDATED": ["Product updated successfully!", "Sản phẩm đã được cập nhật thành công!"],
    "TEXT_PRODUCT_CREATED": ["Product created successfully!", "Sản phẩm đã được tạo thành công!"],
    "TEXT_SAVE_FAILED": ["Failed to save product. Please try again!", "Lưu sản phẩm thất bại. Vui lòng thử lại!"],
    "TEXT_IMAGE_ADDED": ["Image added successfully!", "Đã thêm ảnh thành công!"],
    "TEXT_IMAGE_REMOVED": ["Image removed successfully!", "Đã xóa ảnh thành công!"],
    "TEXT_IMAGE_UPDATED": ["Image updated successfully!", "Đã cập nhật ảnh thành công!"],
    "TEXT_LOGIN": ["Login", "Đăng nhập"],
    "TEXT_LOGIN_DESCRIPTION": ["Please enter your login and password!", "Vui lòng nhập tài khoản và mật khẩu!"],
    "TEXT_USERNAME": ["Username", "Tên đăng nhập"],
    "TEXT_PASSWORD": ["Password", "Mật khẩu"],
    "TEXT_ENTER_USERNAME": ["Enter username", "Nhập tên đăng nhập"],
    "TEXT_ENTER_PASSWORD": ["Password", "Mật khẩu"],
    "TEXT_SET_NEW_PASSWORD": ["Set New Password", "Đặt mật khẩu mới"],
    "TEXT_NEW_PASSWORD": ["New Password", "Mật khẩu mới"],
    "TEXT_CONFIRM_NEW_PASSWORD": ["Confirm New Password", "Xác nhận mật khẩu mới"],
    "TEXT_SET_PASSWORD": ["Set Password", "Đặt mật khẩu"],
    "TEXT_PASSWORD_SET_SUCCESS": ["Password set successfully!", "Đặt mật khẩu thành công!"],
    "TEXT_PASSWORDS_DO_NOT_MATCH": ["New passwords do not match", "Mật khẩu nhập lại không khớp"],
    "TEXT_PASSWORD_TOO_SHORT": ["New password must be at least 6 characters long", "Mật khẩu mới phải có ít nhất 6 ký tự"],
    "TEXT_FAILED_SET_PASSWORD": ["Failed to set password", "Đặt mật khẩu thất bại"],
    "TEXT_MY_ACCOUNT": ["My Account", "Tài khoản"],
    "TEXT_FULL_NAME": ["Full Name", "Họ tên"],
    "TEXT_ACTIVE": ["Active", "Đang hoạt động"],
    "TEXT_INACTIVE": ["Inactive", "Không hoạt động"],
    "TEXT_CREATED_AT": ["Created At", "Ngày tạo"],
    "TEXT_UPDATED_AT": ["Updated At", "Ngày cập nhật"],
    "TEXT_GROUPS": ["Groups", "Nhóm"],
    "TEXT_CHANGE_PASSWORD": ["Change Password", "Đổi mật khẩu"],
    "TEXT_LOGOUT": ["Logout", "Đăng xuất"],
    "TEXT_LOADING": ["Loading...", "Đang tải..."],
    "TEXT_PASSWORD_CHANGED_SUCCESS": ["Password changed successfully!", "Đổi mật khẩu thành công!"],
    "TEXT_FAILED_CHANGE_PASSWORD": ["Failed to change password. Please check your current password.", "Đổi mật khẩu thất bại. Vui lòng kiểm tra mật khẩu hiện tại."],
    "TEXT_CURRENT_PASSWORD": ["Current Password", "Mật khẩu hiện tại"],
    "TEXT_AUTOECOM_ADS": ["AutoEcom Ads", "Quảng cáo AutoEcom"],
    "TEXT_ID": ["ID", "ID"],
    "TEXT_LAST_PING": ["Last Ping", "Ping gần nhất"],
    "TEXT_CONFIG_ADS": ["Config Ads", "Cấu hình Ads"],
    "TEXT_BASE_VALUE": ["Base Value", "Giá trị base"],
    "TEXT_START_HOUR": ["Start Hour", "Giờ bắt đầu"],
    "TEXT_END_HOUR": ["End Hour", "Giờ kết thúc"],
    "TEXT_SAVE_CONFIG": ["Save Config", "Lưu cấu hình"],
    "TEXT_VIEW_CONFIG_HISTORY": ["View Config History", "Xem lịch sử config"],
    "TEXT_CONFIG_HISTORY": ["Config History", "Lịch sử cấu hình"],
    "TEXT_TODAY": ["Today", "Hôm nay"],
    "TEXT_YESTERDAY": ["Yesterday", "Hôm qua"],
    "TEXT_ORDERS": ["Orders", "Đơn hàng"],
    "TEXT_CONFIRM_SELECTED": ["Confirm Selected", "Xác nhận đã chọn"],
    "TEXT_CANCEL_SELECTED": ["Cancel Selected", "Hủy đã chọn"],
    "TEXT_SET_TO_PENDING": ["Set to Pending", "Chuyển về chờ xử lý"],
    "TEXT_CONFIG_VIEW": ["Config View", "Cấu hình hiển thị"],
    "TEXT_DELETE_ORDER": ["Delete Order", "Xóa đơn"],
    "TEXT_CANCEL": ["Cancel", "Hủy"],
    "TEXT_SAVE_CHANGES": ["Save Changes", "Lưu thay đổi"],
    "TEXT_SAVE_VIEW": ["Save View", "Lưu cấu hình"],
    "TEXT_QUANTITY_CHANGE_HISTORY": ["Quantity Change History", "Lịch sử thay đổi số lượng"],
    "TEXT_WAREHOUSE": ["Warehouse", "Kho"],
    "TEXT_CHANGE_AMOUNT": ["Change Amount", "Số lượng thay đổi"],
    "TEXT_UPDATED_QUANTITY": ["Updated Quantity", "Tồn kho sau thay đổi"],
    "TEXT_TYPE": ["Type", "Loại"],
    "TEXT_REFERENCE_ID": ["Reference ID", "Mã tham chiếu"],
    "TEXT_STAFF_NOTE": ["Staff Note", "Ghi chú nhân viên"],
    "TEXT_UPDATED_BY": ["Updated By", "Người cập nhật"],
    "TEXT_DATE": ["Date", "Ngày"],
    "TEXT_ADD_NEW_CHANGE": ["Add New Change", "Thêm thay đổi mới"],
    "TEXT_ADD_NEW_QUANTITY_CHANGE": ["Add New Quantity Change", "Thêm thay đổi số lượng mới"],
    "TEXT_VIEW_QUANTITY_CHANGE": ["View Quantity Change", "Xem thay đổi số lượng"],
    "TEXT_EDIT_QUANTITY_CHANGE": ["Edit Quantity Change", "Sửa thay đổi số lượng"],
    "TEXT_OLD_QUANTITY": ["Old Quantity", "Tồn kho cũ"],
    "TEXT_NEW_QUANTITY": ["New Quantity", "Tồn kho mới"],
    "TEXT_SYSTEM_NOTE": ["System Note", "Ghi chú hệ thống"],
    "TEXT_ORDER_DATE": ["Order Date", "Ngày đặt hàng"],
    "TEXT_ORDER_ID": ["Order ID", "Mã đơn hàng"],
    "TEXT_CUSTOMER": ["Customer", "Khách hàng"],
    "TEXT_BUYER_NOTE": ["Buyer Note", "Ghi chú người mua"],
    "TEXT_SELLER_NOTE": ["Seller Note", "Ghi chú người bán"],
    "TEXT_EST_DELIVERY": ["Est. Delivery", "Dự kiến giao hàng"],
    "TEXT_SHIPPING_ADDRESS": ["Shipping Address", "Địa chỉ giao hàng"],
    "TEXT_EMAIL": ["Email", "Email"],
    "TEXT_EDIT_LISTING_ORDER_NOTE": ["Edit Listing / Order Note", "Sửa thông tin sản phẩm / Ghi chú đơn hàng"],
    "TEXT_LISTING_DETAILS": ["Listing Details", "Chi tiết sản phẩm"],
    "TEXT_ORDER_NOTES": ["Order Notes", "Ghi chú đơn hàng"],
    "TEXT_CONFIGURE_VIEW_COLUMNS": ["Configure View Columns", "Cấu hình cột hiển thị"]
}

export const LANGUAGE_KEYS = {
    "TEXT_TITLE": "TEXT_TITLE",
    "TEXT_GREETING": `TEXT_GREETING`,
    "TEXT_BOT_ID": `TEXT_BOT_ID`,
    "TEXT_JOB_ID": `TEXT_JOB_ID`,
    "TEXT_ALL": `TEXT_ALL`,
    "TEXT_TASK": `TEXT_TASK`,
    "TEXT_FROM": `TEXT_FROM`,
    "TEXT_SEARCH": `TEXT_SEARCH`,
    "TEXT_DAILY_VIEW": `TEXT_DAILY_VIEW`,
    "TEXT_PRICE_MIN": `TEXT_PRICE_MIN`,
    "TEXT_PRICE_MAX": `TEXT_PRICE_MAX`,
    "TEXT_SOLD_30_CALCULATE": `TEXT_SOLD_30_CALCULATE`,
    "TEXT_REVENUE_30_CALCULATE": `TEXT_REVENUE_30_CALCULATE`,
    "TEXT_SOLD_30_COUNT": `TEXT_SOLD_30_COUNT`,
    "TEXT_REVENUE_30_COUNT": `TEXT_REVENUE_30_COUNT`,
    "TEXT_FAVORITE": `TEXT_FAVORITE`,
    "TEXT_FAVORITE_RATE": `TEXT_FAVORITE_RATE`,
    "TEXT_LAST_UPDATE": `TEXT_LAST_UPDATE`,
    "TEXT_SORT_BY": `TEXT_SORT_BY`,
    "TEXT_SORT_ORDER": `TEXT_SORT_ORDER`,
    "TEXT_PRICE": `TEXT_PRICE`,
    "TEXT_TOTAL_VIEWS": `TEXT_TOTAL_VIEWS`,
    "TEXT_CREATED_DATE": `TEXT_CREATED_DATE`,
    "TEXT_EIT_CREATE": `TEXT_EIT_CREATE`,
    "TEXT_EIT_UPDATE": `TEXT_EIT_UPDATE`,
    "TEXT_LAST_CHECK_HEY": `TEXT_LAST_CHECK_HEY`,
    "TEXT_FOUND_X_LISTINGS": `TEXT_FOUND_X_LISTINGS`,
    "TEXT_FLOATING_SEARCH_FILTER": `TEXT_FLOATING_SEARCH_FILTER`,
    "TEXT_PREVIOUS": `TEXT_PREVIOUS`,
    "TEXT_NEXT": `TEXT_NEXT`,
    "TEXT_DAY": `TEXT_DAY`,
    "TEXT_DAYS": `TEXT_DAYS`,
    "TEXT_WEEK": `TEXT_WEEK`,
    "TEXT_WEEKS": `TEXT_WEEKS`,
    "TEXT_MONTH": `TEXT_MONTH`,
    "TEXT_MONTHS": `TEXT_MONTHS`,
    "TEXT_DECREASE": `TEXT_DECREASE`,
    "TEXT_INCREASE": `TEXT_INCREASE`,
    "TEXT_CREATED": `TEXT_CREATED`,
    "TEXT_SEARCH_AND_FILTER": `TEXT_SEARCH_AND_FILTER`,
    "TEXT_COMPETITOR_ANALYSIS": `TEXT_COMPETITOR_ANALYSIS`,
    "TEXT_VISIT_SHOP_X": `TEXT_VISIT_SHOP_X`,
    "TEXT_LISTING": `TEXT_LISTING`,
    "TEXT_COLLECTION_DETAIL": `TEXT_COLLECTION_DETAIL`,
    "TEXT_COLLECTION": `TEXT_COLLECTION`,
    "TEXT_SHOP": `TEXT_SHOP`,
    "TEXT_BOT": `TEXT_BOT`,
    "TEXT_3D_TOOL": `TEXT_3D_TOOL`,
    "TEXT_BOX_MAKER": "TEXT_BOX_MAKER",
    "TEXT_DESIGN_LAMP_TOOL": `TEXT_DESIGN_LAMP_TOOL`,
    "TEXT_DASHBOARD": `TEXT_DASHBOARD`,
    "TEXT_USER_PROFILE": `TEXT_USER_PROFILE`,
    "TEXT_ENTER_KEYWORD": `TEXT_ENTER_KEYWORD`,
    "TEXT_RUNNING_TASKS": `TEXT_RUNNING_TASKS`,
    "TEXT_AUTOMATICALLY_UPDATE_IN_X_SECONDS": `TEXT_AUTOMATICALLY_UPDATE_IN_X_SECONDS`,
    "TEXT_JOB": `TEXT_JOB`,
    "TEXT_STEP": `TEXT_STEP`,
    "TEXT_STATUS": `TEXT_STATUS`,
    "TEXT_PROGRESS": `TEXT_PROGRESS`,
    "TEXT_RUNNING_TIME": `TEXT_RUNNING_TIME`,
    "TEXT_LAST_ACTIVITY": `TEXT_LAST_ACTIVITY`,
    "TEXT_ACTION": `TEXT_ACTION`,
    "TEXT_ASSIGN_JOB": `TEXT_ASSIGN_JOB`,
    "TEXT_X_HOURS_Y_MINUTES": `TEXT_X_HOURS_Y_MINUTES`,
    "TEXT_X_MINUTES_AGO": `TEXT_X_MINUTES_AGO`,
    "TEXT_A_FEW_SECONDS_AGO": `TEXT_A_FEW_SECONDS_AGO`,
    "TEXT_X_HOURS_AGO": `TEXT_X_HOURS_AGO`,
    "TEXT_PING_TIME": `TEXT_PING_TIME`,
    "TEXT_CHECKIN_TIME": `TEXT_CHECKIN_TIME`,
    "TEXT_SCHEDULED_TASKS": `TEXT_SCHEDULED_TASKS`,
    "TEXT_SEARCH_KEYWORD": `TEXT_SEARCH_KEYWORD`,
    "TEXT_SEARCH_TAG": `TEXT_SEARCH_TAG`,
    "TEXT_SEARCH_BY_CATEGORY": `TEXT_SEARCH_BY_CATEGORY`,
    "TEXT_LISTINGS___SHOPS": `TEXT_LISTINGS___SHOPS`,
    "TEXT_TOTAL_SALES": "TEXT_TOTAL_SALES",
    "TEXT_SHOP_SOLD_30_DAYS": "TEXT_SHOP_SOLD_30_DAYS",
    "TEXT_SHOP_SOLD_90_DAYS": "TEXT_SHOP_SOLD_90_DAYS",
    "TEXT_RATING": "TEXT_RATING",
    "TEXT_OPENING_DATE": "TEXT_OPENING_DATE",
    "TEXT_FOUND_X_SHOPS": `TEXT_FOUND_X_SHOPS`,
    "TEXT_LAST_SOLD_DAYS": "TEXT_LAST_SOLD_DAYS",
    "TEXT_TOTAL_LISTINGS": "TEXT_TOTAL_LISTINGS",
    "TEXT_HOUR": "TEXT_HOUR",
    "TEXT_SOLD_CHART": "TEXT_SOLD_CHART",
    "TEXT_IMAGE": "TEXT_IMAGE",
    "TEXT_SKU_CODE": "TEXT_SKU_CODE",
    "TEXT_SIZE": "TEXT_SIZE",
    "TEXT_STYLE": "TEXT_STYLE",
    "TEXT_PRODUCT_NAME": "TEXT_PRODUCT_NAME",
    "TEXT_BASE_PRICE": "TEXT_BASE_PRICE",
    "TEXT_CURRENT_QUANTITY": "TEXT_CURRENT_QUANTITY",
    "TEXT_MATERIAL": "TEXT_MATERIAL",
    "TEXT_COLOR": "TEXT_COLOR",
    "TEXT_DIMENSIONS": "TEXT_DIMENSIONS",
    "TEXT_WEIGHT": "TEXT_WEIGHT",
    "TEXT_ACTIONS": "TEXT_ACTIONS",
    "TEXT_VIEW": "TEXT_VIEW",
    "TEXT_EDIT": "TEXT_EDIT",
    "TEXT_VERSIONS": "TEXT_VERSIONS",
    "TEXT_CLONE": "TEXT_CLONE",
    "TEXT_DELETE": "TEXT_DELETE",
    "TEXT_ADD_NEW_PRODUCT": "TEXT_ADD_NEW_PRODUCT",
    "TEXT_PRODUCT_LIST": "TEXT_PRODUCT_LIST",
    "TEXT_PRODUCT_CODE": "TEXT_PRODUCT_CODE",
    "TEXT_PRODUCT_VERSION": "TEXT_PRODUCT_VERSION",
    "TEXT_PROPERTIES": "TEXT_PROPERTIES",
    "TEXT_IMAGES": "TEXT_IMAGES",
    "TEXT_CLOSE": "TEXT_CLOSE",
    "TEXT_SAVE": "TEXT_SAVE",
    "TEXT_VERSION": "TEXT_VERSION",
    "TEXT_FRIENDLY_VERSION": "TEXT_FRIENDLY_VERSION",
    "TEXT_NOTE": "TEXT_NOTE",
    "TEXT_LENGTH": "TEXT_LENGTH",
    "TEXT_WIDTH": "TEXT_WIDTH",
    "TEXT_HEIGHT": "TEXT_HEIGHT",
    "TEXT_WAREHOUSE_ID": "TEXT_WAREHOUSE_ID",
    "TEXT_IMAGE_URL": "TEXT_IMAGE_URL",
    "TEXT_IMAGE_DESCRIPTION": "TEXT_IMAGE_DESCRIPTION",
    "TEXT_UPDATE_IMAGE": "TEXT_UPDATE_IMAGE",
    "TEXT_ADD_IMAGE": "TEXT_ADD_IMAGE",
    "TEXT_REMOVE": "TEXT_REMOVE",
    "TEXT_PRODUCT": "TEXT_PRODUCT",
    "TEXT_SALE": "TEXT_SALE",
    "TEXT_ADS": "TEXT_ADS",
    "TEXT_SALE_NGACH": "TEXT_SALE_NGACH",
    "TEXT_SCAN_ORDERS": "TEXT_SCAN_ORDERS",
    "TEXT_ORDER_LIST": "TEXT_ORDER_LIST",
    "TEXT_FULFILL": "TEXT_FULFILL",
    "TEXT_FACTORY": "TEXT_FACTORY",
    "TEXT_TABLE_LIST": "TEXT_TABLE_LIST",
    "TEXT_TYPOGRAPHY": "TEXT_TYPOGRAPHY",
    "TEXT_ICONS": "TEXT_ICONS",
    "TEXT_IMPORT": "TEXT_IMPORT",
    "TEXT_EXPORT": "TEXT_EXPORT",
    "TEXT_QUANTITY_CHANGE": "TEXT_QUANTITY_CHANGE",
    "TEXT_TRANSACTIONS": "TEXT_TRANSACTIONS",
    "TEXT_INVENTORY": "TEXT_INVENTORY",
    "TEXT_PRODUCT_UPDATED": "TEXT_PRODUCT_UPDATED",
    "TEXT_PRODUCT_CREATED": "TEXT_PRODUCT_CREATED",
    "TEXT_SAVE_FAILED": "TEXT_SAVE_FAILED",
    "TEXT_IMAGE_ADDED": "TEXT_IMAGE_ADDED",
    "TEXT_IMAGE_REMOVED": "TEXT_IMAGE_REMOVED",
    "TEXT_IMAGE_UPDATED": "TEXT_IMAGE_UPDATED",
    "TEXT_LOGIN": "TEXT_LOGIN",
    "TEXT_LOGIN_DESCRIPTION": "TEXT_LOGIN_DESCRIPTION",
    "TEXT_USERNAME": "TEXT_USERNAME",
    "TEXT_PASSWORD": "TEXT_PASSWORD",
    "TEXT_ENTER_USERNAME": "TEXT_ENTER_USERNAME",
    "TEXT_ENTER_PASSWORD": "TEXT_ENTER_PASSWORD",
    "TEXT_SET_NEW_PASSWORD": "TEXT_SET_NEW_PASSWORD",
    "TEXT_NEW_PASSWORD": "TEXT_NEW_PASSWORD",
    "TEXT_CONFIRM_NEW_PASSWORD": "TEXT_CONFIRM_NEW_PASSWORD",
    "TEXT_SET_PASSWORD": "TEXT_SET_PASSWORD",
    "TEXT_PASSWORD_SET_SUCCESS": "TEXT_PASSWORD_SET_SUCCESS",
    "TEXT_PASSWORDS_DO_NOT_MATCH": "TEXT_PASSWORDS_DO_NOT_MATCH",
    "TEXT_PASSWORD_TOO_SHORT": "TEXT_PASSWORD_TOO_SHORT",
    "TEXT_FAILED_SET_PASSWORD": "TEXT_FAILED_SET_PASSWORD",
    "TEXT_MY_ACCOUNT": "TEXT_MY_ACCOUNT",
    "TEXT_FULL_NAME": "TEXT_FULL_NAME",
    "TEXT_ACTIVE": "TEXT_ACTIVE",
    "TEXT_INACTIVE": "TEXT_INACTIVE",
    "TEXT_CREATED_AT": "TEXT_CREATED_AT",
    "TEXT_UPDATED_AT": "TEXT_UPDATED_AT",
    "TEXT_GROUPS": "TEXT_GROUPS",
    "TEXT_CHANGE_PASSWORD": "TEXT_CHANGE_PASSWORD",
    "TEXT_LOGOUT": "TEXT_LOGOUT",
    "TEXT_LOADING": "TEXT_LOADING",
    "TEXT_PASSWORD_CHANGED_SUCCESS": "TEXT_PASSWORD_CHANGED_SUCCESS",
    "TEXT_FAILED_CHANGE_PASSWORD": "TEXT_FAILED_CHANGE_PASSWORD",
    "TEXT_CURRENT_PASSWORD": "TEXT_CURRENT_PASSWORD",
    "TEXT_AUTOECOM_ADS": "TEXT_AUTOECOM_ADS",
    "TEXT_ID": "TEXT_ID",
    "TEXT_LAST_PING": "TEXT_LAST_PING",
    "TEXT_ACTION": "TEXT_ACTION",
    "TEXT_CONFIG_ADS": "TEXT_CONFIG_ADS",
    "TEXT_BASE_VALUE": "TEXT_BASE_VALUE",
    "TEXT_STEP": "TEXT_STEP",
    "TEXT_START_HOUR": "TEXT_START_HOUR",
    "TEXT_END_HOUR": "TEXT_END_HOUR",
    "TEXT_SAVE_CONFIG": "TEXT_SAVE_CONFIG",
    "TEXT_VIEW_CONFIG_HISTORY": "TEXT_VIEW_CONFIG_HISTORY",
    "TEXT_CONFIG_HISTORY": "TEXT_CONFIG_HISTORY",
    "TEXT_TODAY": "TEXT_TODAY",
    "TEXT_YESTERDAY": "TEXT_YESTERDAY",
    "TEXT_ORDERS": "TEXT_ORDERS",
    "TEXT_CONFIRM_SELECTED": "TEXT_CONFIRM_SELECTED",
    "TEXT_CANCEL_SELECTED": "TEXT_CANCEL_SELECTED",
    "TEXT_SET_TO_PENDING": "TEXT_SET_TO_PENDING",
    "TEXT_CONFIG_VIEW": "TEXT_CONFIG_VIEW",
    "TEXT_DELETE_ORDER": "TEXT_DELETE_ORDER",
    "TEXT_CANCEL": "TEXT_CANCEL",
    "TEXT_SAVE_CHANGES": "TEXT_SAVE_CHANGES",
    "TEXT_SAVE_VIEW": "TEXT_SAVE_VIEW",
    "TEXT_QUANTITY_CHANGE_HISTORY": "TEXT_QUANTITY_CHANGE_HISTORY",
    "TEXT_WAREHOUSE": "TEXT_WAREHOUSE",
    "TEXT_CHANGE_AMOUNT": "TEXT_CHANGE_AMOUNT",
    "TEXT_UPDATED_QUANTITY": "TEXT_UPDATED_QUANTITY",
    "TEXT_TYPE": "TEXT_TYPE",
    "TEXT_REFERENCE_ID": "TEXT_REFERENCE_ID",
    "TEXT_STAFF_NOTE": "TEXT_STAFF_NOTE",
    "TEXT_UPDATED_BY": "TEXT_UPDATED_BY",
    "TEXT_DATE": "TEXT_DATE",
    "TEXT_ADD_NEW_CHANGE": "TEXT_ADD_NEW_CHANGE",
    "TEXT_ADD_NEW_QUANTITY_CHANGE": "TEXT_ADD_NEW_QUANTITY_CHANGE",
    "TEXT_VIEW_QUANTITY_CHANGE": "TEXT_VIEW_QUANTITY_CHANGE",
    "TEXT_EDIT_QUANTITY_CHANGE": "TEXT_EDIT_QUANTITY_CHANGE",
    "TEXT_OLD_QUANTITY": "TEXT_OLD_QUANTITY",
    "TEXT_NEW_QUANTITY": "TEXT_NEW_QUANTITY",
    "TEXT_SYSTEM_NOTE": "TEXT_SYSTEM_NOTE",
    "TEXT_ORDER_DATE": "TEXT_ORDER_DATE",
    "TEXT_ORDER_ID": "TEXT_ORDER_ID",
    "TEXT_CUSTOMER": "TEXT_CUSTOMER",
    "TEXT_BUYER_NOTE": "TEXT_BUYER_NOTE",
    "TEXT_SELLER_NOTE": "TEXT_SELLER_NOTE",
    "TEXT_EST_DELIVERY": "TEXT_EST_DELIVERY",
    "TEXT_SHIPPING_ADDRESS": "TEXT_SHIPPING_ADDRESS",
    "TEXT_EMAIL": "TEXT_EMAIL",
    "TEXT_EDIT_LISTING_ORDER_NOTE": "TEXT_EDIT_LISTING_ORDER_NOTE",
    "TEXT_LISTING_DETAILS": "TEXT_LISTING_DETAILS",
    "TEXT_ORDER_NOTES": "TEXT_ORDER_NOTES",
    "TEXT_CONFIGURE_VIEW_COLUMNS": "TEXT_CONFIGURE_VIEW_COLUMNS"
};

const LANGUAGE_CODES = {
  EN: 0,
  VN: 1
};

export const getCurrentLanguage = () => {
  let currentLanguage = window.localStorage.getItem("eit_language");
  if (!currentLanguage || ["EN", "VN"].indexOf(currentLanguage) === 1) currentLanguage = "VN";

  return currentLanguage.toLowerCase();
};
export const getCurrentLanguageForMoment = () => {
  let currentLanguage = window.localStorage.getItem("eit_language");
  if (!currentLanguage || ["EN", "VN"].indexOf(currentLanguage) === -1) currentLanguage = "VN";
  return currentLanguage.toLowerCase();
};

export const getTranslate = (key, components) => {
  if (!LANGUAGE_KEYS[key]) return key;

  let currentLanguage = window.localStorage.getItem("eit_language");
  if (!currentLanguage || ["EN", "VN"].indexOf(currentLanguage) === -1) currentLanguage = "VN";

  const langCode = LANGUAGE_CODES[currentLanguage];

  if (!components) return LANGUAGES[key][langCode];

  const keys = LANGUAGES[key][langCode].split("[@]");
  // console.log("language @", keys);
  const output = (
    <>
      {keys.map((k, i) => (
        <>
          {k}
          {components[i]}
        </>
      ))}
    </>
  );

  return output;
};

export const getCustomTranslate = (prefix, text, components) => {
  if (!text) return "";

  const modifyText = text.replace("-", "_").replace("(", "").replace(")", "");
  const keyOnly = prefix
    ? [
        prefix,
        modifyText
          .split(" ")
          .filter((v) => v)
          .join("_")
          .toUpperCase(),
      ].join("_")
    : modifyText
        .split(" ")
        .filter((v) => v)
        .join("_")
        .toUpperCase();

  const key = ["TEXT", keyOnly].join("_");

  let tmp = window.localStorage.getItem(`LANG_${prefix}`);

  if (!tmp) tmp = "";

  const line = `${keyOnly}\t${text}\n`;

  if (!tmp.includes(line)) tmp += line;

  window.localStorage.setItem(`LANG_${prefix}`, tmp);

  return getTranslate(key, components);
};
